export default __webpack_public_path__ + "static/media/0000..0001.7bd6ef08.png";